import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
/**
 * Mapping between CategoryId and row
 *
 * Tracks which category is visible based on
 * scrollTop, and virtual rows.
 */
var CategoryTracker = /*#__PURE__*/function () {
  function CategoryTracker() {
    _classCallCheck(this, CategoryTracker);
    this.reset();
  }
  return _createClass(CategoryTracker, [{
    key: "reset",
    value: function reset() {
      this.categoryToRow = new Map();
      this.rowToCategory = new Map();
    }
  }, {
    key: "add",
    value: function add(category, row) {
      if (!this.categoryToRow.has(category)) {
        this.categoryToRow.set(category, row);
        this.rowToCategory.set(row, category);
      }
    }
  }, {
    key: "getRow",
    value: function getRow(category) {
      return this.categoryToRow.get(category);
    }
  }, {
    key: "getFirstCategory",
    value: function getFirstCategory() {
      return this.rowToCategory.get(0);
    }
  }]);
}();
export { CategoryTracker as default };